import {GenericTenant} from '../api/tenants/generic-tenant';

export class TenantsDisplayDialogData {
  tenants: GenericTenant[];
}
